import React, { lazy, Suspense } from "react";

//import DefaultLoader from "../utilities/loaders/DefaultLoader";

import DefaultLoader from "../../utilities/loaders/DefaultLoader";
const PurposeManagementContent = lazy(
  () => import("./PurposeManagementContent"),
);

const PurposeManagement = () => {
  return (
    <Suspense fallback={<DefaultLoader />}>
      <PurposeManagementContent />
    </Suspense>
  );
};

export default PurposeManagement;
